




















import { Component, Vue } from 'vue-property-decorator';
import StatementsTable from '@/components/elements/statement/StatementsTable.vue';
import { StatementsModule } from '@/store/modules/statements';

@Component({
  components: { StatementsTable },
})
export default class LastRequest extends Vue {
  list: any[] = [];

  mounted() {
    this.list = StatementsModule.list;
  }
}
